import { ComponentView, ViewGenerator, ObservableArray, ViewModel } from "binder";
import { TableViewModel } from "./table-viewModel"

export class TableView extends ComponentView<TableViewModel>{
    GetViewUniqueId(): string {
        return "V-48358515-0456-4D23-A3FA-8B0925CE1AB1"
    }
    loadHtml(): string {
        let element = require('./table.html').default;
        let style = require('./table.less');
        return element;
    }
    constructor() {
       super();
       this.displayContentForTBody = false;
    }

    private itemTemplate : Node;
    private itemTemplateMapping:{[id:string]:Node}={};

    templateSelector(vm){
        let newNode : Element;
        if(vm){
            let typeId = vm.getTypeId();
            let result = this.itemTemplateMapping[typeId];
            if(result)
                newNode = ViewGenerator.GetNodeByTemplate(vm,result);
        }
        if(newNode==null)
            newNode =  ViewGenerator.GetNodeByTemplate(vm,this.itemTemplate);
        return newNode;
    }
    nodeContainsCustomTemplate(node:HTMLElement):boolean{
        for (let index = 0; index < node.classList.length; index++) {
            const element = node.classList[index];
            if(element.startsWith('template-')){
                return true;
            }
        }
        return false;
    }

    getNodeCustomTemplateName(node:HTMLElement):string{
        for (let index = 0; index < node.classList.length; index++) {
            const element = node.classList[index];
            if(element.startsWith('template-')){
                let type = element.substring(9);
                return type;
            }
        }
        return null;
    }
    append(...nodes: (Node | string)[]): void{
        nodes.forEach(node=>{
            if(node instanceof HTMLTableSectionElement || node instanceof HTMLTableColElement){
                if(node.nodeName.toUpperCase()=='THEAD' || node.nodeName.toUpperCase()=="COLGROUP"){
                    this.firstlevelElement.prepend(node);
                    // let headerCells = node.rows[0].cells;
                    // for(let i=0;i<headerCells.length;i++){
                    //     let cell = headerCells.item(i);
                    //     this.makeCellSortable(cell);
                    // }
                }else if(node.nodeName.toUpperCase()=='TBODY' && node.classList.contains('notemplate')==false){
                    if(node.classList.contains("template")){
                        let template = <HTMLElement>node;
                        this.itemTemplate = this.removeAsTemplate(template);
                        this.displayContentForTBody = true;
                    }else if(this.nodeContainsCustomTemplate(node)){
                        let type = this.getNodeCustomTemplateName(node);
                        let template = super.removeAsTemplate(node);
                        this.itemTemplateMapping[type]=template;
                    }else if(node.childElementCount>0){
                        for(let i=0;i<node.childElementCount;i++){
                            let innerNode = node.children[i];
                            if(innerNode.classList.contains("template")){
                                let template = <HTMLElement>innerNode;
                                this.itemTemplate = this.removeAsTemplate(template);
                            }else if(innerNode instanceof HTMLElement && this.nodeContainsCustomTemplate(innerNode)){
                                let type = this.getNodeCustomTemplateName(innerNode);
                                let template = super.removeAsTemplate(innerNode);
                                this.itemTemplateMapping[type]=template;
                            }
                        }
                    }
                }else{
                    this.firstlevelElement.append(node);
                }
            }
        });
    }

    // makeCellSortable(cell:HTMLTableDataCellElement){
    //     (<any>cell).sortingInfo={
    //         fieldName:cell.attributes['data-b-sort-column'],
    //         direction:0,
    //         itemsList : this.items
    //     }
    //     cell.addEventListener('click',function(e){
    //         let sortInfo = (<any>this).sortingInfo;
    //         sortInfo.itemsList.sort((x,y)=>{

    //         })
    //     });
    // }

    public set items(v: ObservableArray<ViewModel>) { this._items = v; } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set displayContentForTBody(v: boolean) { this._displayContentForTBody = v; } public get displayContentForTBody(): boolean { return this._displayContentForTBody;} private _displayContentForTBody: boolean;

}
